import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SESSION_MESSAGES } from '../../../study-presence/session-messages';

/**
 * Notification dialog shown to a reviewer when they become surplus to
 * the annotation target (their session was released and the slot filled
 * by another reviewer). Dismissing leaves the warning banner visible.
 */
@Component({
  selector: 'app-surplus-notification-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h2 mat-dialog-title>
      <mat-icon class="dialog-icon">group</mat-icon>
      {{ msg.surplusDialog.title }}
    </h2>
    <mat-dialog-content>
      <p>{{ msg.surplusDialog.body }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-flat-button color="primary" [mat-dialog-close]="true">
        {{ msg.surplusDialog.action }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .dialog-icon {
        vertical-align: middle;
        margin-right: 8px;
        color: #f44336;
      }

      mat-dialog-content p {
        line-height: 1.6;
      }
    `,
  ],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    MatIconModule,
  ],
})
export class SurplusNotificationDialogComponent {
  readonly msg = SESSION_MESSAGES;
}
